import React from "react"
import ReactDOM from "react-dom"
import { Provider } from "react-redux"
import App from "./App"
import setStore from "./globalStore/globalstore"
import "./index.scss"
import "react-toastify/dist/ReactToastify.min.css"
import "react-bootstrap-typeahead/css/Typeahead.css"
import * as serviceWorker from "./serviceWorker"
import SWUpdateDialog from "./features/Tablet/features/Login/SWUpdateDialog"
import "mutation-events"

const store = setStore()
export type AppDispatch = typeof store.dispatch

// ローカルストレージのクリア検知用
window.addEventListener("storage", (e: StorageEvent) => {
  // ローカルストレージがクリアされた場合
  if (e.key == null) {
    // 強制的にリロードを起こしログイン情報を一致させる。
    window.location.reload()
  }
})

ReactDOM.render(
  <React.StrictMode>
    <Provider store={store}>
      <App />
    </Provider>
  </React.StrictMode>,
  document.getElementById("root")
)

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
// serviceWorker.unregister()

// serviceworkerの更新が発生した場合にリロードを促すダイアログを表示させる
serviceWorker.register({
  onUpdate: (registration) => {
    if (registration.waiting) {
      ReactDOM.render(
        <SWUpdateDialog registration={registration} />,
        document.querySelector(".SW-update-dialog")
      )
    }
  },
})
